import { render, staticRenderFns } from "./DepositUseJetonPay.vue?vue&type=template&id=672c1412"
import script from "./DepositUseJetonPay.vue?vue&type=script&lang=js"
export * from "./DepositUseJetonPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports